import React from 'react'

export default function ExclamationMarkIco() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1589 3H10.1367V15H14.1589V3ZM14.1589 19C14.1589 20.1046 13.2585 21 12.1478 21C11.0371 21 10.1367 20.1046 10.1367 19C10.1367 17.8954 11.0371 17 12.1478 17C13.2585 17 14.1589 17.8954 14.1589 19Z"
        fill="#3249D7"
      />
    </svg>
  )
}
